import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

// Endpoint público (sem autenticação).
export function useSaveInterestedClient() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((interestedClient) => {
    setSaving(true);
    return quarkusApi
      .post('/public/interested-client', interestedClient, {})
      .finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
